var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-container info-container pt32"},[_c('Certificate',{staticClass:"mb72",attrs:{"certificate":_vm.certificateData}}),_c('Other',{attrs:{"other":_vm.otherData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }